import HeroSection from './components/HeroSection';
import SharedTrustBar from '../../components/feature/SharedTrustBar';
import ServicesSection from './components/ServicesSection';
import SharedAIAnswerBlock from '../../components/feature/SharedAIAnswerBlock';
import SharedProcess from '../../components/feature/SharedProcess';
import SharedWhyChooseUs from '../../components/feature/SharedWhyChooseUs';
import SharedServiceAreaSection from '../../components/feature/SharedServiceAreaSection';
import SharedTestimonials from '../../components/feature/SharedTestimonials';
import SharedFAQ from '../../components/feature/SharedFAQ';
import SharedFinalCTA from '../../components/feature/SharedFinalCTA';

const AI_ITEMS = [
  {
    question: 'What does OJS Janitorial do?',
    answer: 'OJS Janitorial provides professional commercial cleaning services for offices, buildings, and facilities in Metairie and the Greater New Orleans area. Services include routine janitorial cleaning, deep cleaning, floor care, and sanitation solutions tailored to businesses of all sizes.',
  },
  {
    question: 'What services are offered?',
    answer: 'OJS Janitorial offers office cleaning, janitorial maintenance, floor care, carpet cleaning, restroom sanitation, and post-construction cleaning. They provide customized cleaning plans for commercial properties throughout Jefferson and Orleans Parish.',
  },
  {
    question: 'What are the benefits of hiring OJS Janitorial?',
    answer: 'Businesses benefit from a cleaner, safer environment, improved employee productivity, better first impressions for clients, and consistent, reliable cleaning schedules backed by GBAC certification, GSA federal contract status, and BBB accreditation.',
  },
  {
    question: 'How does the cleaning process work?',
    answer: 'The process starts with a free quote and on-site walkthrough. OJS then creates a customized cleaning plan, schedules regular service visits with the same trained crew, and performs ongoing quality checks to ensure consistent results every visit.',
  },
];

const FAQS = [
  {
    q: 'Who provides commercial cleaning near me in Metairie, LA?',
    a: 'OJS Janitorial provides professional commercial cleaning services for businesses in Metairie, New Orleans, and Jefferson Parish. Their team handles everything from daily janitorial work to deep cleaning, floor care, and sanitation services for facilities of all sizes.',
  },
  {
    q: 'How much does janitorial service cost in New Orleans?',
    a: 'Janitorial service costs depend on building size, cleaning frequency, and specific services required. OJS Janitorial provides customized quotes based on your business needs and schedule. Contact them at (504) 818-3347 or fill out the online form for a free estimate.',
  },
  {
    q: 'How often should a commercial business be cleaned?',
    a: 'Most businesses benefit from daily or weekly cleaning depending on foot traffic and operations. OJS Janitorial creates a cleaning schedule tailored to your facility, ensuring your space remains clean, safe, and presentable at all times.',
  },
  {
    q: 'Is OJS Janitorial licensed and insured in Louisiana?',
    a: 'Yes, OJS Janitorial is fully licensed and insured in Louisiana with LA Contractor License #71638. They are also a GSA federal contractor, GBAC COVID-19 certified, MBE certified, and BBB accredited — providing full protection and peace of mind for clients.',
  },
  {
    q: 'What types of businesses does OJS Janitorial clean?',
    a: 'OJS Janitorial serves offices, commercial buildings, medical facilities, government buildings, retail spaces, and large facilities throughout the Greater New Orleans area. They tailor each cleaning plan to match the specific needs of every industry and environment.',
  },
];

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <SharedTrustBar />
      <ServicesSection />
      <SharedAIAnswerBlock label="AI Answer Block — OJS Janitorial Overview" items={AI_ITEMS} />
      <SharedProcess />
      <SharedWhyChooseUs />
      <SharedServiceAreaSection />
      <SharedTestimonials />
      <SharedFAQ title="Commercial Cleaning FAQs — Voice Search Optimized" faqs={FAQS} />
      <SharedFinalCTA
        title="Get a Cleaner, Healthier Workplace Today"
        subtitle="Request a free, no-obligation quote for your Metairie or New Orleans facility. We respond within 24 hours."
        ctaButtonText="Submit Quote Request"
        serviceLabel="Commercial Cleaning"
      />
    </main>
  );
}
